// services/api/wslAxios.ts
import axios, { AxiosInstance } from "axios";
import store from "../../redux/store";
import { showBlockingSnackbar } from "../../redux/snackbarSlice";

export const wslAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
});

wslAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

wslAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    const isLoginRequest =
      originalRequest?.url?.includes("/patron-login") ||
      originalRequest?.url?.includes("/sip-login") ||
      originalRequest?.url?.includes("/logout");

    const responseData = error?.response?.data;

    // Check for 401 OR custom "Access-token missing" error
    const isUnauthorized =
      error?.response?.status === 401 ||
      (responseData?.status === false &&
        typeof responseData?.data === "string" &&
        responseData.data.includes("Access-token"));

    if (isUnauthorized && !isLoginRequest) {
      localStorage.removeItem("token");
      localStorage.removeItem("library_card");
      localStorage.removeItem("wslUserId");
      localStorage.removeItem("library_name");

      store.dispatch(showBlockingSnackbar({ countdownSeconds: 5 }));
    }

    return Promise.reject(error);
  }
);
